<ng-content></ng-content>
<div class="loading-area clearfix" *ngIf="isLoading">
  <div class="spinner-grow primary abolute-center" role="status">
  </div>
</div>